/**
 * 블록 프로젝트 자동저장 (IndexedDB) — 크래시·탭닫힘·새로고침에서 수업 40분을 지킨다.
 * ⚠️ .sb3는 수 MB(코스튬·사운드 포함)라 localStorage(≈5MB) 부적합 → IndexedDB. (모델 보관함과 같은 판단.)
 * ⭐ 전부 이 기기에만 저장. 서버 전송 0 (프라이버시 퍼스트).
 * 2026-07-23 신설 — 갭 점검에서 "파이썬 코드는 자동저장되는데 블록은 안 됨" 발견.
 */

const DB_NAME = 'curoai-autosave';
const STORE = 'proj';
const KEY = 'current';
const DB_VER = 1;

function openDb () {
    return new Promise((resolve, reject) => {
        let req;
        try {
            req = indexedDB.open(DB_NAME, DB_VER);
        } catch (e) {
            reject(e);
            return;
        }
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, {keyPath: 'key'});
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

// Blob → ArrayBuffer (IDB에 Blob 직접 넣는 건 브라우저별 편차가 있어 버퍼로 저장)
function blobToBuffer (blob) {
    if (blob.arrayBuffer) return blob.arrayBuffer();
    return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = () => reject(fr.error);
        fr.readAsArrayBuffer(blob);
    });
}

// 현재 프로젝트 규모(이어하기 배너 문구 + 빈 프로젝트 걸러내기용)
export function summarize (vm) {
    let blocks = 0;
    let sprites = 0;
    try {
        (vm.runtime.targets || []).forEach(t => {
            if (!t || t.isOriginal === false) return; // 클론 제외
            if (!t.isStage) sprites++;
            const bl = t.blocks && t.blocks._blocks;
            if (bl) {
                Object.keys(bl).forEach(id => {
                    if (bl[id] && !bl[id].shadow) blocks++; // 그림자(기본 입력값) 제외
                });
            }
        });
    } catch (e) { /* noop */ }
    return {blocks, sprites};
}

export function saveProject (vm) {
    const meta = summarize(vm);
    return vm.saveProjectSb3()
        .then(blobToBuffer)
        .then(buf => openDb().then(db => new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, 'readwrite');
            tx.objectStore(STORE).put({
                key: KEY, buf, savedAt: Date.now(), blocks: meta.blocks, sprites: meta.sprites
            });
            tx.oncomplete = () => { db.close(); resolve(Object.assign({bytes: buf.byteLength}, meta)); };
            tx.onerror = () => { db.close(); reject(tx.error); };
        })));
}

export function loadSaved () {
    return openDb().then(db => new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readonly');
        const r = tx.objectStore(STORE).get(KEY);
        r.onsuccess = () => { db.close(); resolve(r.result || null); };
        r.onerror = () => { db.close(); reject(r.error); };
    }));
}

export function clearSaved () {
    return openDb().then(db => new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readwrite');
        tx.objectStore(STORE).delete(KEY);
        tx.oncomplete = () => { db.close(); resolve(); };
        tx.onerror = () => { db.close(); reject(tx.error); };
    }));
}
